export default __webpack_public_path__ + "static/media/Fuzzy_Rain.e23cf075.mp3";